import { render } from "./CompanyProfileOverview.vue?vue&type=template&id=79c47af4&scoped=true"
import script from "./CompanyProfileOverview.vue?vue&type=script&lang=js"
export * from "./CompanyProfileOverview.vue?vue&type=script&lang=js"

import "./CompanyProfileOverview.vue?vue&type=style&index=0&id=79c47af4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c47af4"]])

export default __exports__